const css = `._9PNYdW__topAncestorFlexChild{min-width:0}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"topAncestorFlexChild":"_9PNYdW__topAncestorFlexChild"};
